<template>
    <div
        :style="style"
        :class="classesToUse"
        class="placeholder-box">
            <slot></slot>
    </div>
</template>

<script>
export default {
    name: "PlaceholderBox",
    props: {
        styleObj: Object,
        classes: {
            type: String,
            default: "d-flex align-items-center justify-content-center"
        },
        additionalClasses: {
            type: String,
            default: "",
        },
        color: {
            type: String,
            default: "gray",
        },
        background: {
            type: String,
            default: "rgb(235,235,235)",
        },
        borderRadius: {
            type: String,
            default: "10px",
        },
        width: {
            type: String,
            default: "100%",
        },
        height: {
            type: String,
            default: "100%",
        },
        maxWidth: {
            type: String,
            default: "100%",
        },
        maxHeight: {
            type: String,
            default: '100%',
        },
        minWidth: {
            type: String,
            default: "none",
        },
        minHeight: {
            type: String,
            default: 'none',
        },
    },
    computed: {
        style() {
            if (this.styleObj) return this.styleObj

            return {
                'color': this.color,
                'background': this.background,
                'borderRadius': this.borderRadius,
                'width': this.width,
                'height': this.height,
                'maxWidth': this.maxWidth,
                'maxHeight': this.maxHeight,
                'minWidth': this.minWidth,
                'minHeight': this.minHeight,
            }
        },
        classesToUse() {
            return [this.classes, this.additionalClasses].join(' ')
        },
    },
}
</script>

<style scoped>

</style>